import { useEffect } from 'react';
import { ArtistPortalArtistRef, ArtistPortalAuthKind } from 'fym-shared/src/smartlinks/artistPortals';
import { ServiceConnection } from '../../../redux/api/fymAPI.types';
import { ArtistPortalCardState, artistPortalCardState } from './artistPortalCardState';

interface UseCallbackArtistPickerProps {
  connection: ServiceConnection | undefined;
  loadArtists: (integrationType: string) => Promise<ArtistPortalArtistRef[] | null>;
  onLoaded: (artists: ArtistPortalArtistRef[]) => void;
}

/**
 * Opens the connect sheet on the picker for a YouTube login with several channels.
 *
 * That sign-in returns through music24-api, and the channel list does not
 * travel through the redirect. So when the sheet opens on a connection that
 * still needs an artist, this asks the server for the list. The same holds
 * when the artist presses "Choose artist" on the card later.
 */
export function useCallbackArtistPicker({ connection, loadArtists, onLoaded }: UseCallbackArtistPickerProps): void {
  const integrationTypeToPick =
    connection !== undefined &&
    connection.authKind === ArtistPortalAuthKind.oauthCallback &&
    artistPortalCardState(connection) === ArtistPortalCardState.needsArtist
      ? connection.integrationType
      : undefined;

  useEffect(() => {
    if (integrationTypeToPick === undefined) {
      return;
    }
    loadArtists(integrationTypeToPick)
      .then((loaded) => {
        if (loaded === null || loaded.length === 0) {
          return;
        }
        onLoaded(loaded);
      })
      .catch(console.error);
  }, [integrationTypeToPick, loadArtists, onLoaded]);
}
